import { gate } from 'hub-http/gates';
export const SUBSCRIPTIONS_RECORD_PAYMENT_GATE = gate('Subscriptions:RecordPaymentAutomaticPaymentSubscription');
export const NO_DRAFT_ON_CREATE_GATE = gate('commerce:invoices:noDraftOnCreate');
export const INVOICE_PREVIEW_GATE = gate('commerce:invoices:invoicePreview');
export const INVOICE_PERMISSIONS_GATE = gate('Permissions:Invoices');
export const INVOICES_NET_TERMS_GATE = gate('commerce:invoices:netTerms');
export const REMOVE_PAYMENT_ENROLLMENT_RESTRICTIONS_GATE = gate('commerce:invoices:removePaymentEnrollmentRestrictions');
export const CREDIT_MEMOS_GATE = gate('commerce:invoices:creditMemos');
export const AI_GENERATE_INVOICE_EMAIL_GATE = gate('commerce:invoices:generateInvoiceEmail');